import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/coupon/noList.png'


const _hoisted_1 = { class: "page1" }
const _hoisted_2 = {
  key: 0,
  class: "nothing"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "more_gray"
}
const _hoisted_6 = { class: "dhC" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = { class: "time_gray" }
const _hoisted_10 = { class: "shopName" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "type" }
const _hoisted_14 = { class: "time" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 2,
  style: {"padding-left":"10px","padding-right":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_dialog, {
      show: _ctx.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
      title: "兑换码",
      "show-cancel-button": false,
      "show-confirm-button": false,
      "close-on-click-overlay": true,
      onClose: _ctx.closeDialog,
      "message-align": "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_qrcode_vue, {
          value: _ctx.qrCode123,
          size: _ctx.qcsize
        }, null, 8, ["value", "size"])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    (_ctx.dhrecordList.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dhrecordList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "product",
            key: index
          }, [
            (item.dhStatus == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.couponName), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, "兑换时间:" + _toDisplayString(item.dhTime), 1),
                        _createElementVNode("div", _hoisted_10, "兑换商家:" + _toDisplayString(item.shopName), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.dhStatus == 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(
          item.couponName == '满50元减20元券'
            ? 'more_blue'
            : item.couponName == '满100元减40元券'
            ? 'more_pink'
            : 'more_red'
        )
                }, [
                  _createElementVNode("div", {
                    class: "dhC",
                    onClick: ($event: any) => (_ctx.showDhCode(item.dhCode))
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.couponName), 1),
                      _createElementVNode("div", _hoisted_14, "领取时间:" + _toDisplayString(item.createTime), 1)
                    ])
                  ], 8, _hoisted_11)
                ], 2))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
    _hoisted_15,
    (_ctx.dhrecordList.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
      : _createCommentVNode("", true)
  ]))
}